import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Catalan } from "flatpickr/dist/l10n/cat.js";

export default class extends Controller {
  static values = {
    dayMonth: Boolean,
  };

  connect() {
    this.initializeFlatpickr();
  }

  initializeFlatpickr() {
    const config = {
      altInput: true,
      altFormat: this.dayMonthValue ? "d-F" : "d-F-Y",
      dateFormat: "Y-m-d",
      locale: Catalan,
      onKeyDown: (selectedDates, dateStr, instance, e) => {
        if (e.key === "Tab") {
          e.stopPropagation();
          instance.close();
        }
      },
      onReady: (selectedDates, dateStr, instance) => {
        if (this.dayMonthValue && instance.calendarContainer) {
          const yearElements = instance.calendarContainer.querySelectorAll('.flatpickr-year, .numInputWrapper');
          yearElements.forEach(el => el.style.display = 'none');
        }
      },
      allowInput: true,
      parseDate: (dateStr, format) => {
        const fullDateMatch = dateStr.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{2,4})$/);
        if (fullDateMatch) {
          const day = parseInt(fullDateMatch[1], 10);
          const month = parseInt(fullDateMatch[2], 10);
          let year = parseInt(fullDateMatch[3], 10);

          if (year < 100) year += 2000;

          if (day >= 1 && day <= 31 && month >= 1 && month <= 12) {
            return new Date(year, month - 1, day);
          }
        }

        if (this.dayMonthValue) {
          const dayMonthMatch = dateStr.match(/^(\d{1,2})[-\/](\d{1,2})(?:[-\/]\d+)?$/);
          if (dayMonthMatch) {
            const day = parseInt(dayMonthMatch[1], 10);
            const month = parseInt(dayMonthMatch[2], 10);
            const currentYear = new Date().getFullYear();

            if (day >= 1 && day <= 31 && month >= 1 && month <= 12) {
              return new Date(currentYear, month - 1, day);
            }
          }
        }
        return flatpickr.parseDate(dateStr, format);
      },
    };

    flatpickr(this.element, config);
  }
}
